import request from '@/libs/request';

export const GetArticleH5List = (data = {}) => request('GetArticleH5List', data); // 获取文章列表
export const UpdArticleH5Status = (data = {}) => request('UpdArticleH5Status', data); // 更新文章列表状态
export const GetArticleH5UrlByID = (data = {}) => request('GetArticleH5UrlByID', data); // 获取链接地址
export const GetArticleH5ByTagID = (data = {}) => request('GetArticleH5ByTagID', data); // 通过标签id返回文章信息
export const AEditArticleH5 = (data = {}) => request('AEditArticleH5', data); // 编辑h5
export const GetArticleH5ByID = (data = {}) => request('GetArticleH5ByID', data); // 根据id读取h5
export const GetLinkAddress = (data = {}) => request('GetLinkAddress', data); // 获取文章分享链接
